// @flow
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { DEPTH, BORDER_RADIUS, color } from '@tablekit/theme';
import { isValidLink } from 'components/Link';

export const MOBILE_SIZE = 265;
export const SMALL_SIZE = 280;
export const MEDIUM_SIZE = 320;
export const LARGE_SIZE = 380;

export const FULL_TOP_IMAGE_CLASS = 'full-top-image';

export const HOVER_SCALE = 1.02;

const Card = styled('div')`
  display: flex;
  flex-direction: column;
  // for IE11
  min-height: 1px;

  color: ${color('text')};

  &,
  &:visited,
  &:active,
  &:hover {
    text-decoration: none !important;
  }

  ${(props) => {
    const { onClick, href, to, link, useLinkAnimation } = props;
    if (!(onClick || href || to || isValidLink(link) || useLinkAnimation)) {
      return css`
        border-radius: ${BORDER_RADIUS}px;
        background-color: ${color('surface')(props)};
        ${DEPTH.OVERLAY};
      `;
    }
    return css`
      cursor: pointer;
      position: relative;
      & > * {
        z-index: 1;
      }
      &:before {
        content: '';
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: ${BORDER_RADIUS}px;
        background-color: ${color('surface')(props)};
        ${DEPTH.OVERLAY};
        z-index: 0;
        transition-duration: 0.2s;
        transition-timing-function: ease-in-out;
        transition-property: box-shadow, transform;
      }
      &:hover:before {
        ${DEPTH.FLOAT};
        transform: scale(${HOVER_SCALE});
      }
      & .${FULL_TOP_IMAGE_CLASS} {
        transform-origin: bottom center;
        border-top-left-radius: ${BORDER_RADIUS}px;
        border-top-right-radius: ${BORDER_RADIUS}px;
        transition: transform 0.2s ease-in-out;
      }
      &:hover .${FULL_TOP_IMAGE_CLASS} {
        transform: scale(${HOVER_SCALE});
      }
    `;
  }};
`;

export default Card;
